import request from '@/utils/request'

// 登录
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}

// 退出
export function logOut(data) {
  return request({
    url: '/logout',
    method: 'post',
    data: data
  })
}

// 当前登录人信息
export function GetLoginUser(data) {
  return request({
    url: '/SystemBase/SysUser/GetLoginUser',
    method: 'get',
    data: data
  })
}
